import { Component, Injector, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import _moment from 'proxies/dayjs';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { AsideBarService } from 'src/modules/base/services/asideBar.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { ThisReceiver } from '@angular/compiler';

@Component({
    selector: 'app-view-count-grid',
    templateUrl: './view-count-grid.component.html',
    standalone: false
})
export class ViewCountGridComponent extends UiEngineComponent {
  mySubscription: any;
  tabChange: boolean = false;
  scheme_id: any;
  ip_banner: any;
  file_arg: any; disbledTimePickerRange:any ={};
  actTab: any;
  tabClick: boolean = false;
  viewCount: boolean = false;
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  showPopUp: boolean = true;
  resourceDef: any = false;
  sidebarOpen: any;
  locale = {
    "format": "DD/MM/YYYY HH:mm"
  }
  serviceItemRequired: boolean= true;
  to: any;
  config: any;
  age: number;
  greaterage: number;
  lessage: number;
  from_date: string;
  sideBarLoading = true;
  care_type: any = "";
  serviceList: any =[]
  serviceItemList: any = [];
  limit = 10;
  page = 0;
  pageSize = 10;
  itemsCount: any;
  services: any = [];
  searchKey: any ='';
  isNonPayerPaybleItem: boolean= false;
  serviceType: any = '';
  serviceItemId: any;
  serviceDate: any;
  resourceDef1: any;
  operator: any;
  options: any= [];
  slotDay: string;
  admission_date_time: any;
  dec_p: any;
  f_type:any;
  specialityAgeRequired: boolean = true;
   btn: any;
   decorator_nm:any;
   due_api_data:any;
   dueResDef:any;
  configApproval = {
  "customButtonsAllowed":false,
  "allowPagination":false,
  "allowConfigGrid":false,
  "hideSearchBox":true,
  "help":false
  }
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    public asideBarService: AsideBarService,
    public sessionStorage: StorageService,
    public loader: LoaderService
  ) {
    super(injector, router, route, modal)
    this.communicationService.emitSidebar({ sidebar: true });
    this.config = {
      "submitButton": false,
      "cancelButton": false,
      "filterForm": false,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": ''
    }
    // this.router.events.subscribe((e: any) => {
    //   if (e instanceof NavigationEnd) {
    //     this.ngOnInit();
    //   }
    // });
  }

  ngOnInit() {
    // if(sessionStorage.getItem('currentData')!=undefined && sessionStorage.getItem('currentData')){
    //   let uniqueKeys = ["uhId","id"];
    //   this.storageService.setTabId(sessionStorage.getItem('currentData'),uniqueKeys);
    // }
    if (this.route?.snapshot?.queryParams?.tab_0 === "admission_approval") {
      this.f_type = "popup";
      let resource = 'new_adm_pop'
      this.baseService.getResourceDef(resource, (data) => {
        console.log("value is :: ", data);
        this.resourceDef = data;
        this.decorator_nm = this.baseService.initDecorator("RequestApprovalDecorator", this.route, this.injector);
        sessionStorage.setItem("currentData_adm", JSON.stringify(this['data']));
        this.btn = (this.resourceDef?.form?.buttons && Object.keys(this.resourceDef.form.buttons).length)
          ? this.resourceDef.form.buttons
          : {
            "Add": [
              {
                "action_name": "final_action",
                "label": "Approve",
                "icon": "fa fa-check"
              },
              {
                "action_name": "draft_action",
                "label": "Reject",
                "icon": "fa fa-save"
              }
            ]
          };

      });
    }
    else {
        if (this.formService.appService.getUniversalConfig('multi_care_type')) {
      this.care_type = this.appService.getDynamicFunctions("getCurrentCareType")
    }
    let resource = 'auto_consultation'
    this.baseService.getResourceDef(resource, (data) => {
      console.log("value is :: ", data);
      this.resourceDef = data;
      this.sessionStorage.setCurrentResource('auto_consultation');
    });
  }
    //this.dec_p=this.baseService.initDecorator("AutoConsultationDecorator", this.route, this.injector);
    super.ngOnInit();
  }

  ngAfterViewInit() {
    this.checkSidebarOpen();
  }
  getDataFn(event) {
    if (event.type == 'form') {
      this.config.formGroup = event.obj;
    }
  }
  onSaveFinished(e) {
    let res = "due_amount_alert"
    this.baseService.getResourceDef(res, (data) => {
      console.log("value is :: ", data);
      this.dueResDef = data;
    })
    let args = 'uhId:' + this['data']['uhId'];
    this.baseService.get('GET_DUE_AMOUNT_POP_UP', args, 'billing_details', 'billing').subscribe((result) => {
      if (result.errCode == 0 && result.resource && result.resource.length > 0) {
        this.due_api_data = result;
      }
      else {
        this.formService.alerts.error("No Dues!!")
      }
    })
  }
  questionValueChanged(data) {
    if(!(this.route?.snapshot?.queryParams?.tab_0 === "admission_approval"))
    {
    this.serviceList = []
    if(this.config?.formGroup?.controls?.booking_type?.value == "Auto Admission" && data.question && data.question.question && data.question.question.key == "admission_date_time"){
      let resource1 = 'view_admission_actual_count'
      this.baseService.getResourceDef(resource1, (data) => {
      console.log("value is :: ", data);
      this.resourceDef1 = data;
      this.sessionStorage.setCurrentResource('view_admission_actual_count');
    });
    }
    if(this.config?.formGroup?.controls?.booking_type?.value == "Auto Consultation" && data.question && data.question.question && data.question.question.key == "serviceDate"){
      let resource1 = 'view_actual_count'
      this.baseService.getResourceDef(resource1, (data) => {
      console.log("value is :: ", data);
      this.resourceDef1 = data;
      this.sessionStorage.setCurrentResource('view_actual_count');
    });
    }
    if(data.question.question.key == "serviceDate" && data.form.controls['serviceDate'].value){
      this.serviceDate = data.question.question.value;
    }
    if(data.question.question.key == "serviceItemName" && this.specialityAgeRequired==true && data.form.controls['speciality_id'].value != ""){
      this.viewCount = false
      this.specialityAgeRequired =false
      this.serviceItemId = data.form.controls.serviceItemId.value;
      this.serviceType = data.question.question.key;
      if(data && data.form.controls['speciality_id'].value != ""){
        let options = data.form.controls['speciality_id'].question_component.formService.compositeQuestionMapping.gender_counts.gender_code.options;
        this.formService.baseService.getById(data.form.controls['speciality_id'].value, 'facility_master_speciality_master', 'facility-management').subscribe(
          result => {
            this.specialityAgeRequired=true
            this.age = result.age
            this.greaterage = Number(this.age) + 1;
            this.lessage = Number(this.age) - 1;
            this.operator = result.age_operator_code
            if(this.operator == "equal"){
              data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue(this.age)
              data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue(this.age)
            }
            else if(this.operator == "lessThan"){
              data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue(1)
              data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue(this.lessage)
            }
            else if(this.operator == "greaterThan"){
              data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue(this.greaterage)
              data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue(100)
            }
            else{
              data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue("")
              data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue("")
            }
            if(data.form.controls['applicable_for_women'].value){
              if(this.serviceList.length == 0){
                let val = {
                  "code": "female",
                  "display": "Female"
                }
                this.serviceList.push(val)
                data.form.controls['speciality_id'].question_component.formService.compositeQuestionMapping.gender_counts.gender_code.options = this.serviceList
                data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_code.setValue("female")
                data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_name.setValue("Female")
              }
            }
            else{
              this.formService.baseService.get('get_valueset_by_id_flat', "resourceId:gender,system:karexpert", 'valueset', 'system-management').subscribe(
                result => {
                  data.form.controls['speciality_id'].question_component.formService.compositeQuestionMapping.gender_counts.gender_code.options = result.resource;
                  data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_code.setValue("male")
                  data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_name.setValue("Male")
                })
            }
        });
      }
    }
    if(data.form.controls['admission_date_time'] && (data.form.controls['admission_date_time'].value == "" || data.form.controls['admission_date_time'].value == null) && data && data.question && data.question.question && data.question.question.key && (data.question.question.key == "booking_type" || (data.question.question.key == "admission_date_time" && data.question.question.value == null)) && data.form.controls['booking_type'].value == "Auto Admission"){
      var currentDateTime = new Date().getTime();
      data.form.controls['admission_date_time'].setValue(currentDateTime);
      this.admission_date_time = currentDateTime
      data.form.controls['admission_date_time'].question_component.question.value = currentDateTime
      data.form.controls['admission_date_time'].updateValueAndValidity();
  }
  if(data.form.controls['serviceDate'] && (data.form.controls['serviceDate'].value == "" || data.form.controls['serviceDate'].value == null) && data && data.question && data.question.question  && (data.question.question.key == "booking_type" || (data.question.question.key == "serviceDate" && data.question.question.value == null)) && data.form.controls['booking_type'].value == "Auto Consultation"){
      var currentDateTime = new Date().getTime();
      data.form.controls['serviceDate'].setValue(currentDateTime);
      data.form.controls['serviceDate'].question_component.question.value = currentDateTime
      this.serviceDate = currentDateTime
      data.form.controls['serviceDate'].updateValueAndValidity();
      this.options = data.form.controls['serviceDate'].question_component.formService.compositeQuestionMapping.gender_counts.gender_code.options;
  }
    if(data && data.question && data.question.question && data.question.question.key == "speciality_code" && data.form.controls['speciality_code'].value !="" && this.serviceItemRequired==true){
      let slotDate = _moment(this.serviceDate).subtract(0, 'days').startOf('day').valueOf();
      this.slotDay = _moment(this.serviceDate).format("dd");
      this.serviceItemRequired = false;
    let args = 'speciality_code:' + data.form.controls['speciality_code'].value + ',' + 'event_start_date:' + slotDate + ',' + 'days:' + this.slotDay.toUpperCase() + ',practice_type_code:individual,serviceItemCode:opd'  + ',' + 'care_type:' + this.care_type;
      this.formService.baseService.get('DOCTOR_BY_SPECIALITY_AND_SCHEDULE_PROVISIONAL', args, 'schedule_event', 'facility-management').subscribe(
          result => {
              if (result.errCode == 0 && result.resource.length > 0) {
                data.form.controls['serviceItemId'].question_component.question.datasource = { application: "facility-management", resource: "schedule_event", args: args, query_id: "DOCTOR_BY_SPECIALITY_AND_SCHEDULE_PROVISIONAL" };
                data.form.controls['serviceItemId'].question_component.question.defaultsetting.advancesearch.datasource = { application: "facility-management", resource: "schedule_event", args: args, query_id: "DOCTOR_BY_SPECIALITY_AND_SCHEDULE_PROVISIONAL" };
                data.form.controls['serviceItemId'].question_component.question.options = result.resource;
                data.form.controls.serviceItemId.setValue(result.resource[0].doctor_id);
                data.form.controls['serviceItemId'].question_component.question.value = result.resource[0].doctor_id
                data.form.controls.serviceItemId.updateValueAndValidity();
                data.form.controls.serviceItemName.setValue(result.resource[0].display_name);
                data.form.controls['serviceItemName'].question_component.question.value = result.resource[0].display_name
                data.form.controls.serviceItemName.updateValueAndValidity();
                data.form.controls.serviceItemCode.setValue(result.resource[0].doctor_code);
                data.form.controls['serviceItemCode'].question_component.question.value = result.resource[0].doctor_code
                data.form.controls.serviceItemCode.updateValueAndValidity();
                data.form.controls.department_name.setValue(result.resource[0].department_name);
                data.form.controls['department_name'].question_component.question.value = result.resource[0].department_name
                data.form.controls.department_name.updateValueAndValidity();
                data.form.controls.department_id.setValue(result.resource[0].department_id);
                data.form.controls['department_id'].question_component.question.value = result.resource[0].department_id
                data.form.controls.department_id.updateValueAndValidity();
                data.form.controls.subDepartment_name.setValue(result.resource[0].subDepartment_name);
                data.form.controls['subDepartment_name'].question_component.question.value = result.resource[0].subDepartment_name
                data.form.controls.subDepartment_name.updateValueAndValidity();
                data.form.controls.subDepartment_id.setValue(result.resource[0].subDepartment_id);
                data.form.controls['subDepartment_id'].question_component.question.value = result.resource[0].subDepartment_id
                data.form.controls.subDepartment_id.updateValueAndValidity();
                this.serviceItemRequired = true;
              }
              else{
                this.viewCount=false;
                data.form.controls['serviceItemId'].question_component.question.datasource = { application: "facility-management", resource: "schedule_event", args: args, query_id: "DOCTOR_BY_SPECIALITY_AND_SCHEDULE_PROVISIONAL" };
                data.form.controls['serviceItemId'].question_component.question.defaultsetting.advancesearch.datasource = { application: "facility-management", resource: "schedule_event", args: args, query_id: "DOCTOR_BY_SPECIALITY_AND_SCHEDULE_PROVISIONAL" };
                data.form.controls['serviceItemId'].question_component.question.options = result.resource;
                data.form.controls.serviceItemId.setValue("");
                data.form.controls.serviceItemId.updateValueAndValidity();
                data.form.controls.serviceItemName.setValue("");
                data.form.controls.serviceItemName.updateValueAndValidity();
                data.form.controls.serviceItemCode.setValue("");
                data.form.controls.serviceItemCode.updateValueAndValidity();
                data.form.controls.department_name.setValue("");
                data.form.controls.department_name.updateValueAndValidity();
                data.form.controls.department_id.setValue("");
                data.form.controls.department_id.updateValueAndValidity();
                data.form.controls.subDepartment_name.setValue("");
                data.form.controls.subDepartment_name.updateValueAndValidity();
                data.form.controls.subDepartment_id.setValue("");
                data.form.controls.subDepartment_id.updateValueAndValidity();
                if(data.form.controls['applicable_for_women'].value){
                  if(this.serviceList.length == 0){
                    let val = {
                      "code": "female",
                      "display": "Female"
                    }
                    this.serviceList.push(val)
                    data.form.controls['speciality_id'].question_component.formService.compositeQuestionMapping.gender_counts.gender_code.options = this.serviceList
                    data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_code.setValue("female")
                    data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_name.setValue("Female")
                  }
                }
                else{
                  this.formService.baseService.get('get_valueset_by_id_flat', "resourceId:gender,system:karexpert", 'valueset', 'system-management').subscribe(
                    result => {
                      data.form.controls['serviceItemId'].question_component.formService.compositeQuestionMapping.gender_counts.gender_code.options = result.resource;
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_code.setValue("male")
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_name.setValue("Male")
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue("")
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue("")
                    })
                }
                this.formService.baseService.getById(data.form.controls['speciality_id'].value, 'facility_master_speciality_master', 'facility-management').subscribe(
                  result => {
                    this.age = result.age
                    this.greaterage = Number(this.age) + 1;
                    this.lessage = Number(this.age) - 1;
                    this.operator = result.age_operator_code
                    if(this.operator == "equal"){
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue(this.age)
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue(this.age)
                    }
                    else if(this.operator == "lessThan"){
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue(1)
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue(this.lessage)
                    }
                    else if(this.operator == "greaterThan"){
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue(this.greaterage)
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue(100)
                    }
                    else{
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue("")
                      data.form.controls['speciality_id'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue("")
                    }
                });
                  // this.formService.alerts.error(result.message)
                  this.serviceItemRequired = true;
                  if(data.form.controls.serviceItemId.value == ""){
                    this.viewCount = false
                    this.serviceItemId = data.form.controls.serviceItemId.value;
                  }
              }
          }
      );
    }
    if(data && data.question && data.question.question && data.question.question.key == "facility_id"){
      this.formService.baseService.get('GET_PAYER', '', 'payer', 'facility-management').subscribe(
        result => {
          if (result.errCode == 0 && result.resource.length > 0) {
            data.form.controls.payer_id.question_component.question.options= result.resource
            data.form.controls.payer_id.question_component.question.options.forEach(res=>{
              if (res._default == true) {
                data.form.controls.payer_id.setValue(res.id);
                data.form.controls.payer_name.setValue(res.payer_name);
              }
            })
          }
        });
      }
      if(data.question.question.key == "specialityId"){
        this.viewCount = false
        this.serviceType = data.question.question.key;
        this.serviceItemId = data.form.controls.specialityId.value;
        this.formService.baseService.getById(data.form.controls['specialityId'].value, 'facility_master_speciality_master', 'facility-management').subscribe(
          result => {
            this.age = result.age
            this.greaterage = Number(this.age) + 1;
            this.lessage = Number(this.age) - 1;
            this.operator = result.age_operator_code
            if(this.operator == "equal"){
              data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue(this.age)
              data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue(this.age)
            }
            else if(this.operator == "lessThan"){
              data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue(1)
              data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue(this.lessage)
            }
            else if(this.operator == "greaterThan"){
              data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue(this.greaterage)
              data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue(100)
            }
            else{
              data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.start_age.setValue("")
              data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.end_age.setValue("")
            }
            if(data.form.controls['applicable_for_women'].value){
              if(this.serviceList.length == 0){
                let val = {
                  "code": "female",
                  "display": "Female"
                }
                this.serviceList.push(val)
                data.form.controls['specialityId'].question_component.formService.compositeQuestionMapping.gender_counts.gender_code.options = this.serviceList
                data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_code.setValue("female")
                data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_name.setValue("Female")
              }
            }
            else{
              this.formService.baseService.get('get_valueset_by_id_flat', "resourceId:gender,system:karexpert", 'valueset', 'system-management').subscribe(
                result => {
                  data.form.controls['specialityId'].question_component.formService.compositeQuestionMapping.gender_counts.gender_code.options = result.resource;
                  data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_code.setValue("male")
                  data.form.controls['specialityId'].question_component.formService.compositeFormMapping.gender_counts.controls.gender_name.setValue("Male")
                })
            }
        });
      }
  }
}
  get_data(form){
    this._currentData.dataGridConfig.customButtonsAllowed=false;
    this._currentData.dataGridConfig.allowPagination=false;
    this._currentData.dataGridConfig.allowConfigGrid=false;
    this._currentData.dataGridConfig.hideSearchBox=true;
    this._currentData.dataGridConfig.help=false;
    this.viewCount=true
    if(this.config.formGroup.controls.booking_type.value == "Auto Consultation"){
      let refddata = {
        filter: "FROMTOKEY:slotStartTime,FROM:" + _moment(this.serviceDate).startOf('day').valueOf()  + ",TO:" + _moment(this.serviceDate).endOf('day').valueOf() + ",treatingDoctorId:" + this.serviceItemId,
        page_size: 10,
        query_id: "CONSULTATION_PROVISIONAL_COUNT"
      }
      this._currentData.decorator = this.baseService.initDecorator("AutoConsultationDecorator", this.route, this.injector);
      this.bindGridWithoutPrint(refddata, "", "appointment", "appointment", "");
    }
    if(this.config.formGroup.controls.booking_type.value == "Auto Admission"){
      let refddata = {
        filter: "FROMTOKEY:admission_date_time,FROM:" + _moment(this.admission_date_time).startOf('day').valueOf()  + ",TO:" + _moment(this.admission_date_time).endOf('day').valueOf() + ",currentTreatingDoctorId:" + this.config.formGroup.controls.treating_doctor_id.value,
        page_size: 10,
        query_id: "ADMISSION_PROVISIONAL_COUNT"
      }
      this._currentData.decorator = this.baseService.initDecorator("AutoConsultationDecorator", this.route, this.injector);
      this.bindGridWithoutPrint(refddata, "", "bulk_service_booking", "adt", "");
    }
  }
  
  ngOnDestroy() {
    // this.resetDublicasyHistory();
    if (this.modal != undefined) {
      this.modal._hideBackdrop();
      this.modal._hideModal(1);
      this.modal.hide(1);
    }
    this.communicationService.emitSidebar({ sidebar: true });
  }
  createBill(event) {
    if(this.config.formGroup.controls.booking_type.value == ""){
      this.formService.alerts.error("Please select Booking Type before proceed!!!")
      return
    }
    if(this.config.formGroup.controls.booking_type.value == "Auto Consultation"){
      if(this.config.formGroup.controls.serviceDate.value == "" && this.config.formGroup.controls.booking_type.value == "Auto Consultation"){
        this.formService.alerts.error("Please select Consultation Date before proceed!!!")
        return
      }
      else if(this.config.formGroup.controls.speciality_code.value == "" && this.config.formGroup.controls.booking_type.value == "Auto Consultation"){
        this.formService.alerts.error("Please select Speciality Details before proceed!!!")
        return
      }
      else if(this.config.formGroup.controls.serviceItemId.value == "" && this.config.formGroup.controls.booking_type.value == "Auto Consultation"){
        this.formService.alerts.error("Please select Doctor Details before proceed!!!")
        return
      }
      else if(this.config.formGroup.controls.priorityCode.value == "" && this.config.formGroup.controls.booking_type.value == "Auto Consultation"){
        this.formService.alerts.error("Please select Priority before proceed!!!")
        return
      }
      else if(this.config.formGroup.controls.payer_id.value == "" && this.config.formGroup.controls.booking_type.value == "Auto Consultation"){
        this.formService.alerts.error("Please select Payer Details before proceed!!!")
        return
      }
      else if(this.config.formGroup.controls.consultation_type_code.value == "" && this.config.formGroup.controls.booking_type.value == "Auto Consultation"){
        this.formService.alerts.error("Please select consultation type before proceed!!!")
        return
      }
      else if(this.config.formGroup.controls.gender_counts.value.length == 0){
        this.formService.alerts.error("Please add atleast one value in the table from above form!!!")
        return
      }
      else{
        let response = {
          "booking_type": this.config.formGroup.controls.booking_type.value,
          "serviceDate": this.config.formGroup.controls.serviceDate.value,
          "speciality_display": this.config.formGroup.controls.speciality_display.value,
          "speciality_name": this.config.formGroup.controls.speciality_name.value,
          "serviceType": this.config.formGroup.controls.serviceType.value,
          "serviceItemCode": this.config.formGroup.controls.serviceItemCode.value,
          "serviceItemName": this.config.formGroup.controls.serviceItemName.value,
          "department_id": this.config.formGroup.controls.department_id.value,
          "department_name": this.config.formGroup.controls.department_name.value,
          "subDepartment_name": this.config.formGroup.controls.subDepartment_name.value,
          "subDepartment_id": this.config.formGroup.controls.subDepartment_id.value,
          "treating_doctor_name": this.config.formGroup.controls.treating_doctor_name.value,
          "unit_display_name": this.config.formGroup.controls.unit_display_name.value,
          "speciality_id": this.config.formGroup.controls.speciality_id.value,
          "facility_id": this.config.formGroup.controls.facility_id.value,
          "speciality_code": this.config.formGroup.controls.speciality_code.value,
          "serviceItemId": this.config.formGroup.controls.serviceItemId.value,
          "priorityCode": this.config.formGroup.controls.priorityCode.value,
          "payer_id": this.config.formGroup.controls.payer_id.value,
          "consultation_type_code": this.config.formGroup.controls.consultation_type_code.value,
          "payer_name": this.config.formGroup.controls.payer_name.value,
          "payer_type_name": this.config.formGroup.controls.payer_type_name.value,
          "priority": this.config.formGroup.controls.priority.value,
          "payer_type": this.config.formGroup.controls.payer_type.value,
          "consultation_type": this.config.formGroup.controls.consultation_type.value,
          "serviceType_code": this.config.formGroup.controls.serviceType_code.value,
          "gender_counts": this.config.formGroup.controls.gender_counts.value
        }
        if(response && response.consultation_type_code == "opd"){
          response["consultation_type"] = "OP"
      }
      if(response && response.priorityCode == "routine"){
          response["priority"] = "Routine"
      }
      this.loader.showSpinner()
        this.formService.baseService.action(response, 'BULK_BOOKING', 'order', 'bulk_service_booking').subscribe((data) => {
          if (data.errCode == 0) {
              this.formService.alerts.success("Request Successful");
              this.formService.baseService.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
              this.loader.hideSpinner();
          }
          else {
              this.formService.alerts.error(data.message)
              this.loader.hideSpinner();
          }
      })
    }
    }
    if(this.config.formGroup.controls.booking_type.value == "Auto Admission"){
      if(this.config.formGroup.controls.admission_date_time.value == "" && this.config.formGroup.controls.booking_type.value == "Auto Admission"){
        this.formService.alerts.error("Please select Admission Date before proceed!!!")
        return
      }
      else if(this.config.formGroup.controls.unit_code.value.length == 0 && this.config.formGroup.controls.booking_type.value == "Auto Admission"){
        this.formService.alerts.error("Please select Unit Details before proceed!!!")
        return
      }
      else if(this.config.formGroup.controls.treating_doctor_id.value.length == 0 && this.config.formGroup.controls.booking_type.value == "Auto Admission"){
        this.formService.alerts.error("Please select Treating Doctor Details before proceed!!!")
        return
      }
      else if(this.config.formGroup.controls.payer_id.value.length == 0 && this.config.formGroup.controls.booking_type.value == "Auto Admission"){
        this.formService.alerts.error("Please select Payer Details before proceed!!!")
        return
      }
      else if(this.config.formGroup.controls.gender_counts.value.length == 0){
        this.formService.alerts.error("Please add atleast one value in the table from above form!!!")
        return
      }
      else{
        let response = {
          "booking_type": this.config.formGroup.controls.booking_type.value,
          "admission_date_time": this.config.formGroup.controls.admission_date_time.value,
          "speciality_display": this.config.formGroup.controls.speciality_display.value,
          "speciality_name": this.config.formGroup.controls.speciality_name.value,
          "serviceType": this.config.formGroup.controls.serviceType.value,
          "serviceItemCode": this.config.formGroup.controls.serviceItemCode.value,
          "serviceItemName": this.config.formGroup.controls.serviceItemName.value,
          "department_id": this.config.formGroup.controls.department_id.value,
          "department_name": this.config.formGroup.controls.department_name.value,
          "subDepartment_name": this.config.formGroup.controls.subDepartment_name.value,
          "subDepartment_id": this.config.formGroup.controls.subDepartment_id.value,
          "treating_doctor_name": this.config.formGroup.controls.treating_doctor_name.value,
          "treating_doctor_id": this.config.formGroup.controls.treating_doctor_id.value,
          "unit_display_name": this.config.formGroup.controls.unit_display_name.value,
          "unit_code": this.config.formGroup.controls.unit_code.value,
          "speciality_id": this.config.formGroup.controls.specialityId.value,
          "facility_id": this.config.formGroup.controls.facility_id.value,
          "payer_id": this.config.formGroup.controls.payer_id.value,
          "consultation_type_code": this.config.formGroup.controls.consultation_type_code.value,
          "payer_name": this.config.formGroup.controls.payer_name.value,
          "payer_type_name": this.config.formGroup.controls.payer_type_name.value,
          "payer_type": this.config.formGroup.controls.payer_type.value,
          "consultation_type": this.config.formGroup.controls.consultation_type.value,
          "serviceType_code": this.config.formGroup.controls.serviceType_code.value,
          "gender_counts": this.config.formGroup.controls.gender_counts.value
        }
        if(response && response.consultation_type_code == "opd"){
          response["consultation_type"] = "OP"
      }
      this.loader.showSpinner()
        this.formService.baseService.action(response, 'BULK_ADMISSION', 'adt', 'bulk_service_booking').subscribe((data) => {
          if (data.errCode == 0) {
              this.formService.alerts.success("Request Successful");
              this.formService.baseService.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
              this.loader.hideSpinner();
          }
          else {
              this.formService.alerts.error(data.message)
              this.loader.hideSpinner();
          }
      })
    }
    }
  }
}
